"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerIcon = exports.SpinnerAndTextWrapper = exports.LoadingMoreText = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const SpinnerAndTextWrapper = exports.SpinnerAndTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "Spinnerstyle__SpinnerAndTextWrapper",
  componentId: "sc-13lein4-0"
})(["margin:auto;margin-top:", ";margin-bottom:9px;display:flex;flex-direction:column;align-items:center;"], _uiKit.theme.spacing.BASE_3);
const LoadingMoreText = exports.LoadingMoreText = _styledComponents.default.div.withConfig({
  displayName: "Spinnerstyle__LoadingMoreText",
  componentId: "sc-13lein4-1"
})(["margin-top:8px;font-size:11px;line-height:18px;padding-bottom:", ";color:", ";"], _uiKit.theme.spacing.BASE_3, _uiKit.theme.colours.NEUTRALS_2);
const SpinnerIcon = exports.SpinnerIcon = (0, _styledComponents.default)(_uiKit.Icon).withConfig({
  displayName: "Spinnerstyle__SpinnerIcon",
  componentId: "sc-13lein4-2"
})(["animation:spinner 2s infinite linear;height:26px !important;width:", " !important;color:", ";@keyframes spinner{100%{transform:rotate(360deg);}}"], _uiKit.theme.spacing.BASE_3, _uiKit.theme.colours.NEUTRALS_4);